// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__hOX8r","contactForm":"Contact_contactForm__-G4AG","contactField":"Contact_contactField__A12dU"};